import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import upperCase from 'lodash/upperCase'

import { observer } from 'mobx-react'

import buildUrl from 'modules/core/lib/buildUrl'

// TODO: This file will be removed once we enable dev_time_planning_balances_in_shifts
// eslint-disable-next-line factorial/no-allowed-mobx-collections
import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { EmployeeAvatar } from 'modules/employees/components/EmployeeAvatar'
import { useCurrentViewOptions } from 'modules/shift_management/hooks/useCurrentViewOptions'
import type { ShiftsRow } from 'modules/shift_management/lib/types'

import ShiftsRowCheckbox from '../EmployeeInfoCell/ShiftsRowCheckbox'
import HoursInformation from './HoursInformation'

interface Props {
  shiftsRow: ShiftsRow
  contractVersions: ContractVersions
}

const EmployeeCellContent = ({ shiftsRow, contractVersions }: Props) => {
  const { viewOptions } = useCurrentViewOptions()
  const {
    employee: { showJobPosition },
  } = viewOptions

  const employee = shiftsRow.employees[0]

  return (
    <Box width="full">
      <Box
        flexDirection="row"
        gap="s8"
        width="full"
        justifyContent="spaceBetween"
        alignItems="flexStart"
      >
        <Box flexDirection="row" gap="s8" flexGrow minWidth="s0">
          {employee ? (
            <EmployeeAvatar
              variant="medium"
              employee={{
                id: employee.id,
                access: {
                  id: employee.id,
                  fullName: employee.fullName,
                  avatar: employee.avatar,
                },
              }}
            />
          ) : (
            <Avatar size="s32" url={buildUrl(shiftsRow.avatar)} label={shiftsRow.title} />
          )}
          <Box gap="s6" flexGrow minWidth="s0">
            <Box gap="s4" minWidth="s0">
              <Text size="200" weight="semibold" color="grey1000" ellipsis>
                {shiftsRow.title}
              </Text>
              {showJobPosition && (
                <Text size="100" color="grey1000" ellipsis>
                  {upperCase(shiftsRow.job)}
                </Text>
              )}
            </Box>
            <HoursInformation shiftsRow={shiftsRow} contractVersions={contractVersions} />
          </Box>
        </Box>
        <Box flexNoShrink>
          <ShiftsRowCheckbox shiftsRow={shiftsRow} />
        </Box>
      </Box>
    </Box>
  )
}

export default observer(EmployeeCellContent)
